import { ClientReceipt, PAGES, ReceiptsTabProps } from "@dune/types";
import { DataTable } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetClientReceipts } from "../../../api/queries/clients.queries";
import { clientReceiptsColumns } from "./receiptTab/clientReceiptsColumns";

const ReceiptsTab: React.FC<ReceiptsTabProps> = ({ client }) => {
	const navigate = useNavigate();

	const {
		data: receipts = [],
		isLoading,
		error,
	} = useGetClientReceipts(
		client.id.toString(),
		undefined,
		client.clientType || undefined,
	);

	const columns = clientReceiptsColumns();

	const handleRowClick = (receipt: ClientReceipt) => {
		navigate(
			`${PAGES.PROPOSALS.show.withParams(receipt.proposition.id.toString())}?tab=receipts`,
		);
	};

	if (error) {
		return (
			<div className="p-6">
				<div className="text-red-600">
					Erreur lors du chargement des quittances: {error.message}
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center justify-between mb-6">
				<div className="text-2xl font-semibold text-gray-900">Quittances</div>
			</div>

			<DataTable
				data={receipts}
				columns={columns}
				isLoading={isLoading}
				onRowClick={handleRowClick}
				noResultsText="Aucune quittance"
			/>
		</div>
	);
};

export default ReceiptsTab;
